module.exports = __webpack_public_path__ + "static/media/Government House, Lahore c. 1869.bd54f85a.jpg";